import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SectionBadgeProps {
  icon?: LucideIcon;
  text: string;
  color?: 'purple' | 'amber' | 'blue' | 'green' | 'orange' | 'cyan' | 'pink' | 'indigo' | 'gold';
  className?: string;
}

const colorMap = {
  purple: 'bg-slate-900/90 border-slate-800 text-slate-300',
  amber: 'bg-slate-900/90 border-slate-800 text-slate-300',
  blue: 'bg-slate-900/90 border-slate-800 text-slate-300',
  green: 'bg-slate-900/90 border-slate-800 text-emerald-400',
  orange: 'bg-slate-900/90 border-slate-800 text-slate-300',
  cyan: 'bg-slate-900/90 border-slate-800 text-slate-300',
  pink: 'bg-slate-900/90 border-slate-800 text-slate-300',
  indigo: 'bg-slate-900/90 border-slate-800 text-slate-300',
  gold: 'bg-slate-900/90 border-slate-800 text-slate-300',
};

export function SectionBadge({ icon: Icon, text, color = 'purple', className }: SectionBadgeProps) {
  return (
    <div
      className={cn(
        'inline-flex items-center gap-2 px-3 py-1 rounded-full border text-xs font-bold uppercase tracking-wider',
        colorMap[color],
        className
      )}
    >
      {Icon && <Icon className="w-4 h-4" />}
      {text}
    </div>
  );
}

export default SectionBadge;
